import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 24px;
`;
